export default {
      id: "financial-security-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#financial-security",
      toString: function () {
        return this.url;
      }
    }